/**
 * PERSONA 5 ROYAL AJAX CART DRAWER ENGINE
 * Handles async Shopify /cart.js API updates and P5R Save Menu overlay UI rendering.
 */

(function () {
  'use strict';

  var P5RCart = {
    overlay: null,
    backdrop: null,
    closeBtn: null,
    stackContainer: null,
    subtotalElem: null,
    countBadges: [],
    isOpen: false,
    motion: null,

    init: function () {
      this.overlay = document.getElementById('p5rCartOverlay');
      if (!this.overlay) return;

      this.backdrop = this.overlay.querySelector('.p5r-cart-backdrop');
      this.closeBtn = this.overlay.querySelector('.p5r-cart-close');
      this.stackContainer = this.overlay.querySelector('#p5rCartStackContainer');
      this.subtotalElem = this.overlay.querySelector('#p5rCartSubtotal');
      this.countBadges = document.querySelectorAll('.p5r-hdr-cart-badge, .p5r-hud-cart-badge, [data-cart-count]');

      if (typeof window.Persona5CartMotion !== 'undefined') {
        this.motion = new window.Persona5CartMotion(this.overlay);
      }

      this.bindEvents();
    },

    bindEvents: function () {
      var self = this;

      // Header cart trigger buttons & Quick Add buttons
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('.p5r-hdr-cart, [data-cart-drawer-trigger], .p5r-cart-trigger');
        if (trigger) {
          e.preventDefault();
          self.toggle();
          return;
        }

        // [+] Add Item Quick Add button click listener
        var quickAddBtn = e.target.closest('.js-p5r-quick-add');
        if (quickAddBtn && !quickAddBtn.classList.contains('is-adding')) {
          e.preventDefault();
          var variantId = quickAddBtn.getAttribute('data-variant-id');
          if (!variantId) return;

          var card = quickAddBtn.closest('.p5r-product-card');
          var addedText = card ? card.getAttribute('data-added-text') : '[✓] Added';
          if (!addedText) addedText = '[✓] Added';

          var originalText = quickAddBtn.innerHTML;
          quickAddBtn.classList.add('is-adding');
          quickAddBtn.innerHTML = '<span class="p5r-btn-text">ADDING...</span>';

          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            quickAddBtn.classList.remove('is-adding');
            quickAddBtn.classList.add('is-added');
            quickAddBtn.innerHTML = '<span class="p5r-btn-text">' + addedText + '</span>';

            if (window.showP5RToast) {
              var itemTitle = card ? (card.querySelector('.p5r-product-card__title') ? card.querySelector('.p5r-product-card__title').textContent.trim() : 'ITEM') : 'ITEM';
              window.showP5RToast(itemTitle, '', 1);
            }

            self.refresh();

            setTimeout(function () {
              quickAddBtn.classList.remove('is-added');
              quickAddBtn.innerHTML = originalText;
            }, 2000);
          })
          .catch(function (err) {
            console.error('Quick add error:', err);
            quickAddBtn.classList.remove('is-adding');
            quickAddBtn.innerHTML = originalText;
          });
        }
      });

      // Close button
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          self.close();
        });
      }

      // Backdrop click to close
      if (this.backdrop) {
        this.backdrop.addEventListener('click', function (e) {
          e.preventDefault();
          self.close();
        });
      }

      // Escape key listener
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.isOpen) {
          self.close();
        }
      });

      // Delegate quantity change & remove clicks inside cart stack
      if (this.stackContainer) {
        this.stackContainer.addEventListener('click', function (e) {
          var qtyBtn = e.target.closest('.p5r-cart-qty-btn');
          var removeBtn = e.target.closest('.p5r-cart-item-remove');

          if (qtyBtn) {
            var key = qtyBtn.getAttribute('data-item-key');
            var card = qtyBtn.closest('.p5r-cart-card');
            var valSpan = card ? card.querySelector('.p5r-cart-qty-val') : null;
            var currentQty = valSpan ? parseInt(valSpan.textContent, 10) : parseInt(qtyBtn.getAttribute('data-current-qty'), 10);
            if (isNaN(currentQty)) currentQty = 1;

            var change = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
            var newQty = Math.max(0, currentQty + change);

            // Optimistic UI update: update local DOM values immediately
            if (card) {
              if (valSpan) valSpan.textContent = newQty;
              var allBtns = card.querySelectorAll('.p5r-cart-qty-btn');
              allBtns.forEach(function (b) {
                b.setAttribute('data-current-qty', newQty);
              });
            }

            self.changeQuantity(key, newQty);
          } else if (removeBtn) {
            var removeKey = removeBtn.getAttribute('data-item-key');
            self.changeQuantity(removeKey, 0);
          }
        });
      }

      // Mobile swipe navigation & PayPal hint interaction
      var swipeHint = document.getElementById('p5rCartMobileSwipeHint');
      var swipeContainer = document.querySelector('.p5r-cart-swipe-container');
      var swipeDots = document.querySelectorAll('.p5r-cart-dossier-dots .p5r-dot');

      if (swipeHint && swipeContainer) {
        swipeHint.addEventListener('click', function () {
          var isAtStart = swipeContainer.scrollLeft < 40;
          swipeContainer.scrollTo({
            left: isAtStart ? swipeContainer.scrollWidth : 0,
            behavior: 'smooth'
          });
        });
      }

      if (swipeContainer && swipeDots.length > 0) {
        swipeContainer.addEventListener('scroll', function () {
          var isPageTwo = swipeContainer.scrollLeft > (swipeContainer.scrollWidth / 4);
          swipeDots.forEach(function (dot, idx) {
            dot.classList.toggle('is-active', (idx === 1 && isPageTwo) || (idx === 0 && !isPageTwo));
          });
          if (swipeHint) {
            var arrow = swipeHint.querySelector('.p5r-dossier-paypal-arrow');
            if (arrow) {
              arrow.style.transform = isPageTwo ? 'rotate(180deg)' : 'rotate(0deg)';
            }
          }
        }, { passive: true });

        swipeDots.forEach(function (dot, idx) {
          dot.addEventListener('click', function () {
            swipeContainer.scrollTo({
              left: idx * (swipeContainer.scrollWidth / 2),
              behavior: 'smooth'
            });
          });
        });
      }
    },

    toggle: function () {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },

    open: function () {
      if (this.isOpen) return;
      var self = this;
      this.isOpen = true;

      this.overlay.classList.add('is-active');
      document.body.classList.add('p5r-cart-open');
      this.overlay.setAttribute('aria-hidden', 'false');

      // Schedule GSAP motion animation on next frame after initial paint (60fps liquid smooth)
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (self.motion) {
            self.motion.play();
          }
        });
      });

      // Defer background fetch until entrance animation completes (500ms)
      setTimeout(function () {
        self.fetchCartData();
      }, 500);
    },

    close: function () {
      if (!this.isOpen) return;
      var self = this;
      this.isOpen = false;

      var finishClose = function () {
        self.overlay.classList.remove('is-active');
        document.body.classList.remove('p5r-cart-open');
        self.overlay.setAttribute('aria-hidden', 'true');
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
      };

      if (this.motion && typeof this.motion.exit === 'function') {
        this.motion.exit(finishClose);
      } else {
        finishClose();
      }
    },

    refresh: function () {
      this.fetchCartData();
    },

    fetchCartData: function (callback) {
      var self = this;
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          self.renderCart(cart);
          self.updateHeaderBadge(cart.item_count);
          if (callback) callback();
        })
        .catch(function (err) {
          console.error('[P5R Cart] Error fetching cart:', err);
          if (callback) callback();
        });
    },

    changeQuantity: function (key, quantity) {
      var self = this;
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          self.renderCart(cart);
          self.updateHeaderBadge(cart.item_count);
        })
        .catch(function (err) {
          console.error('[P5R Cart] Error changing quantity:', err);
        });
    },

    updateHeaderBadge: function (count) {
      var badges = document.querySelectorAll('.p5r-hdr-cart-badge, .p5r-hud-cart-badge, [data-cart-count]');
      badges.forEach(function (badge) {
        badge.textContent = count;
        if (count === 0) {
          badge.classList.add('is-empty');
        } else {
          badge.classList.remove('is-empty');
        }
      });
    },

    formatMoney: function (cents, format) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, format);
      }
      var formatString = (window.Shopify && window.Shopify.money_format) ? window.Shopify.money_format : '${{amount}}';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var match = formatString.match(placeholderRegex);
      if (!match) {
        return '$' + (cents / 100).toFixed(2);
      }

      function defaultOption(opt, def) {
        return (typeof opt === 'undefined' ? def : opt);
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsFormatted = parts[1] ? (decimal + parts[1]) : '';

        return dollars + centsFormatted;
      }

      var value = '';
      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
          break;
      }

      return formatString.replace(placeholderRegex, value);
    },

    renderCart: function (cart) {
      if (!this.stackContainer) return;

      // Update Subtotal Display
      if (this.subtotalElem) {
        this.subtotalElem.textContent = this.formatMoney(cart.total_price);
      }

      // Update PayPal Button dynamically
      var paypalBtn = document.querySelector('.p5r-paypal-checkout-btn');
      if (paypalBtn) {
        var paypalTotalCents = cart.total_price + 2500;
        var urlPrice = (paypalTotalCents / 100).toFixed(2);
        paypalBtn.href = "https://www.paypal.com/paypalme/junxbootleg/" + urlPrice + "USD";
        var paypalBtnText = paypalBtn.querySelector('.p5r-paypal-btn-text') || paypalBtn.querySelector('span:last-child');
        if (paypalBtnText) {
          paypalBtnText.textContent = "PAY WITH PAYPAL [ " + this.formatMoney(paypalTotalCents) + " ]";
        }
      }

      // Empty Cart State
      if (!cart.items || cart.items.length === 0) {
        this.stackContainer.innerHTML = [
          '<div class="p5r-cart-empty">',
            '<h2 class="p5r-cart-empty-title">YOUR CART IS EMPTY</h2>',
            '<p class="p5r-cart-empty-text">// Your stash is currently empty.</p>',
            '<a href="/collections/all" class="p5r-cart-continue-btn">SHOP NOW</a>',
          '</div>'
        ].join('');
        return;
      }

      // Render P5R Save Slot Item Cards (Fresh render ensures all variant details are accurate)
      var html = '<ul class="p5r-cart-stack">';
      var self = this;

      cart.items.forEach(function (item, index) {
        var itemPriceFormatted = self.formatMoney(item.final_line_price);
        var itemVariantText = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        var imgHtml = item.image ? '<img class="p5r-cart-item-img" src="' + item.image + '" alt="' + (item.product_title || '') + '" loading="lazy" width="55" height="55" />' : '';

        html += [
          '<li class="p5r-cart-card" style="--card-rot: ' + (index % 2 === 0 ? '1.5deg' : '-1.5deg') + ';">',

            '<!-- Product Image & Details -->',
            '<div class="p5r-cart-item-main">',
              imgHtml,
              '<div class="p5r-cart-item-details">',
                '<a href="' + item.url + '" class="p5r-cart-item-title">' + (item.product_title || '') + '</a>',
                (itemVariantText ? '<span class="p5r-cart-item-variant">// ' + itemVariantText + '</span>' : ''),
              '</div>',
            '</div>',

            '<!-- Quantity Controls -->',
            '<div class="p5r-cart-qty-wrap">',
              '<button type="button" class="p5r-cart-qty-btn" data-item-key="' + item.key + '" data-current-qty="' + item.quantity + '" data-qty-change="-1" aria-label="Decrease quantity">-</button>',
              '<span class="p5r-cart-qty-val">' + item.quantity + '</span>',
              '<button type="button" class="p5r-cart-qty-btn" data-item-key="' + item.key + '" data-current-qty="' + item.quantity + '" data-qty-change="1" aria-label="Increase quantity">+</button>',
            '</div>',

            '<!-- Line Price -->',
            '<div class="p5r-cart-item-price">' + itemPriceFormatted + '</div>',
            '<!-- Remove Button -->',
            '<button type="button" class="p5r-cart-item-remove" data-item-key="' + item.key + '" aria-label="Remove item">&times;</button>',
          '</li>'
        ].join('');
      });

      html += '</ul>';
      this.stackContainer.innerHTML = html;
    }
  };

  window.P5RCart = P5RCart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { P5RCart.init(); });
  } else {
    P5RCart.init();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail.sectionId === 'cart-drawer' || e.detail.sectionId === 'header') {
      P5RCart.init();
    }
  });
})();
